<script setup lang="ts">
const props = defineProps<{ value: number; label?: string }>()
</script>

<template>
  <div class="progress" role="progressbar" :aria-label="label ?? 'Progresso'" aria-valuemin="0" aria-valuemax="100" :aria-valuenow="Math.round(props.value)">
    <span :style="{ width: `${Math.max(0, Math.min(100, props.value))}%` }" />
  </div>
</template>

<style scoped>
.progress { height: 8px; overflow: hidden; border-radius: var(--radius-full); background: var(--ck-cream-300); }
.progress span { display: block; height: 100%; border-radius: inherit; background: var(--ck-flame); transition: width 240ms ease-out; }
</style>

